export interface MiniQuestionnaireData {
  // Questions initiales
  age: string;
  sexe: string;
  tabac_regulier: string;
  
  // Activité physique
  renforcement_musculaire: string;
  
  // Tabac
  fume_actuellement: string;
  annees_tabagisme: string;
  cigarettes_par_jour: string;
  exposition_tabagisme_passif: string;
  
  // Alcool
  frequence_alcool: string;
  
  // Nutrition
  viande_rouge_frequence: string;
  regime_mediterraneen: string;
  
  // Sommeil
  heures_sommeil: string;
  
  // Dépistages effectués
  depistages_effectues: string[];
}

export const initialMiniQuestionnaireData: MiniQuestionnaireData = {
  age: "",
  sexe: "",
  tabac_regulier: "",
  renforcement_musculaire: "",
  fume_actuellement: "",
  annees_tabagisme: "",
  cigarettes_par_jour: "",
  exposition_tabagisme_passif: "",
  frequence_alcool: "",
  viande_rouge_frequence: "",
  regime_mediterraneen: "",
  heures_sommeil: "",
  depistages_effectues: []
};
